import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import authService from '../../services/authService';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);
    try {
      const result = await authService.forgotPassword(email);
      if (result?.success) {
        setSubmitted(true);
        toast.success(result.message ?? 'Check your email for the reset link.');
      } else {
        const msg = result?.message ?? 'Failed to send reset link.';
        setError(msg);
        toast.error(msg);
      }
    } catch (err) {
      const data = err?.response?.data;
      const msg =
        (typeof data?.message === 'string' && data.message) ||
        data?.error ||
        err?.message ||
        'Something went wrong. Please try again.';
      setError(msg);
      toast.error(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full max-w-md px-4 py-8 sm:py-12">
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm sm:p-8">
        <h1 className="text-xl font-semibold text-gray-900 sm:text-2xl">
          Reset password
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Enter your admin email and we’ll send you a link to reset your password.
        </p>

        {submitted ? (
          <div className="mt-6 rounded-lg bg-primary-muted p-4 text-sm text-gray-700">
            <p className="font-medium text-primary">Check your email</p>
            <p className="mt-1">
              If an account exists for <span className="font-medium">{email}</span>, you’ll receive a password reset link. You can close this page after checking your inbox.
            </p>
            <Link
              to="/login"
              className="mt-4 inline-block text-sm font-medium text-primary hover:text-primary-hover"
            >
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 space-y-5">
            {error && (
              <div className="rounded-lg bg-red-50 p-3 text-sm text-red-700">
                {error}
              </div>
            )}
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-gray-900 placeholder-gray-400 focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary sm:text-sm"
                placeholder="you@company.com"
              />
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full rounded-lg bg-primary px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-hover focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-60"
            >
              {isSubmitting ? 'Sending…' : 'Send reset link'}
            </button>

            <p className="text-center">
              <Link
                to="/login"
                className="text-sm font-medium text-primary hover:text-primary-hover"
              >
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
